import React from "react";

import { cx } from "~/tools/class-variance";

import styles from "./_table.module.css";

export type TableCellProps = React.ComponentPropsWithoutRef<"div">;

export const TableCell = React.forwardRef<React.ComponentRef<"div">, TableCellProps>((props, ref) => (
	<div ref={ref} role="cell" {...props} className={cx(styles.cell, props.className)} />
));
